import { FC } from 'react';

/**
 * Fixed, global footer. The extra bottom padding keeps the brand line clear of
 * the paywall's fixed checkout bar when scrolled to the very bottom.
 */
const Footer: FC = () => (
  <footer className="border-t border-landing-hairline bg-landing-surface px-6 pt-8 pb-32 text-center">
    <p className="mx-auto max-w-md text-xs leading-relaxed text-landing-slate">
      Fantasy Football Hub. Winning at fantasy football just got easier.
    </p>
  </footer>
);

export default Footer;
